import { Clock3 } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/libs/utils';
import type { WalletExpiryPresentation } from '@/shared/utils/walletExpiry';

interface WalletExpiryLabelProps {
  expiry: WalletExpiryPresentation;
}

function expiryTone(expiry: WalletExpiryPresentation): string {
  if (expiry.state === 'urgent') return 'font-semibold text-[#92400E]';
  if (expiry.state === 'soon') return 'font-medium text-[#A16207]';
  if (expiry.state === 'expired' || expiry.state === 'invalid') return 'font-medium text-[#B91C1C]';
  return 'font-medium text-[#777777]';
}

function LabelContent({ expiry }: WalletExpiryLabelProps) {
  return (
    <>
      {expiry.showClock ? <Clock3 aria-hidden="true" className="size-3.5 shrink-0" /> : null}
      <span>{expiry.label}</span>
    </>
  );
}

export function WalletExpiryLabel({ expiry }: WalletExpiryLabelProps) {
  if (!expiry.label) return null;
  const className = cn('inline-flex items-center gap-2 rounded px-1 text-left text-[12px]', expiryTone(expiry));
  if (!expiry.exactLabel) return <div className={className}><LabelContent expiry={expiry} /></div>;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="wallet-expiry-trigger"
          className={cn(className, 'min-h-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-motitoBlue')}
        >
          <LabelContent expiry={expiry} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto max-w-[calc(100vw-2rem)] px-3 py-2 text-sm">
        {expiry.exactLabel}
      </PopoverContent>
    </Popover>
  );
}
